import React, { useState, useContext, useEffect } from 'react';
import { Row, Button, Col, Form, Card, Badge, Spinner } from 'react-bootstrap';
import { FiCalendar, FiUsers, FiCheck, FiDollarSign, FiPrinter, FiFileText, FiEye } from 'react-icons/fi';
import { FaCalendarAlt } from 'react-icons/fa';
import moment from 'moment';
import 'moment/locale/es';
import { Link, useNavigate } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';

import { AppContext } from '../AppContext';
import { tre } from '../trebus';

export default function Month() {
    const context = useContext(AppContext);
    const navigate = useNavigate();
    const [fees, setFees] = useState([]);
    const [, setPayments] = useState([]);
    const [year, setYear] = useState(parseInt(moment().format('Y')));
    const [month, setMonth] = useState(parseInt(moment().format('M')));
    const [generatingAll, setGeneratingAll] = useState(false);
    const [totalMonth, setTotalMonth] = useState(0);
    const [loading, setLoading] = useState(false);
    const [collectingId, setCollectingId] = useState(null);
    const [generatingId, setGeneratingId] = useState(null);

    // Earlier months
    const monthsInAdvance = 4;
    const my = [];
    moment.locale('es');
    const m = moment().add(monthsInAdvance, 'month');
    for (let i = 0; i < 20; i++) {
        my.push({
            id: i,
            month: parseInt(m.format('MM')),
            year: parseInt(m.format('YYYY')),
            name: m.format('MMMM YYYY')
        });
        m.subtract(1, 'month');
    }
    const [monthYears] = useState(my);

    const getMonth = () => {
        setLoading(true);

        tre.api('GET', '/fees', {
            context: context,
            params: { year, month },
            success: (r) => {
                setFees(r);

                const pays = [];
                let total = 0;

                for (const i in r) {
                    if (r[i].py_id) {
                        pays.push({
                            id: r[i].py_id,
                            month: r[i].py_month,
                            year: r[i].py_year,
                            user: { full_name: r[i].full_name },
                            price: r[i].py_price
                        });
                    }
                    total = total + parseFloat(r[i].totalPrice);
                }
                setPayments(pays);
                setTotalMonth(total);
                setLoading(false);
            },
            error: () => setLoading(false)
        });
    };

    useEffect(() => {
        getMonth();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [month]);

    const onDateChange = (ev) => {
        const my = monthYears[ev.target.value];
        setYear(my.year);
        setMonth(my.month);
    };

    const generatePayment = (fee) => {
        setGeneratingId(fee.id);
        tre.api('POST', '/fees/users/' + fee.id + '/payments', {
            context: context,
            params: { year, month },
            success: () => {
                getMonth();
                setGeneratingId(null);
            },
            error: () => setGeneratingId(null)
        });
    };

    const seePayment = (idPay) => {
        navigate('/payment/' + idPay);
    };

    const generateAll = () => {
        setGeneratingAll(true);
        tre.api('POST', '/fees/users/payments', {
            context: context,
            params: { year, month },
            success: () => {
                getMonth();
                setGeneratingAll(false);
                NotificationManager.success('Todos los cobros generados');
            },
            error: () => setGeneratingAll(false)
        });
    };

    const downloadAllReceipts = () => {
        window.open(
            `${tre.url}/companies/${context.idCompany}/payments.pdf?year=${year}&month=${month}`
        );
    };

    const collect = (idPayment) => {
        setCollectingId(idPayment);
        tre.api('PUT', '/payments/' + idPayment + '/collect', {
            context: context,
            success: () => {
                NotificationManager.success('Cobrado');
                getMonth();
                setCollectingId(null);
            },
            error: () => setCollectingId(null)
        });
    };

    const currentMY = monthYears[monthYears.findIndex(my => (my.year === year) && (my.month === month))];

    // Stats
    const totalUsers = fees.length;
    const totalPaid = fees.filter(f => f.py_is_paid === 1).length;
    const totalPending = fees.filter(f => f.py_id && f.py_is_paid === 0).length;

    return (
        <div className="container-fluid py-4" style={{ maxWidth: '1400px' }}>
            {/* Header */}
            <div className="d-flex flex-wrap align-items-center justify-content-between mb-4 gap-3">
                <div>
                    <h4 className="mb-1" style={{ color: '#202124', fontWeight: 500 }}>
                        <FiCalendar className="me-2" style={{ color: '#1a73e8' }} />
                        Contabilidad Mensual
                    </h4>
                    <p className="text-muted mb-0" style={{ fontSize: '14px' }}>
                        Gestión de cobros y pagos mensuales
                    </p>
                </div>

                {/* Month Selector */}
                <div className="d-flex align-items-center gap-2">
                    <FaCalendarAlt style={{ color: '#5f6368' }} />
                    <Form.Select
                        value={currentMY?.id || 0}
                        disabled={loading}
                        onChange={onDateChange}
                        style={{ minWidth: '180px' }}
                    >
                        {monthYears.map((m) => (
                            <option value={m.id} key={m.id}>
                                {m.name}
                            </option>
                        ))}
                    </Form.Select>
                </div>
            </div>

            {/* Stats Row */}
            <Row className="g-3 mb-4">
                <Col md={3} sm={6}>
                    <Card style={{ border: 'none', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
                        <Card.Body className="p-3">
                            <div className="d-flex align-items-center">
                                <div
                                    className="d-flex align-items-center justify-content-center rounded-circle me-3"
                                    style={{ width: '48px', height: '48px', backgroundColor: '#e8f0fe' }}
                                >
                                    <FiUsers style={{ color: '#1a73e8' }} size={22} />
                                </div>
                                <div>
                                    <div className="text-muted" style={{ fontSize: '13px' }}>Usuarios</div>
                                    <div className="fs-4 fw-bold" style={{ color: '#1a73e8' }}>{totalUsers}</div>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={3} sm={6}>
                    <Card style={{ border: 'none', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
                        <Card.Body className="p-3">
                            <div className="d-flex align-items-center">
                                <div
                                    className="d-flex align-items-center justify-content-center rounded-circle me-3"
                                    style={{ width: '48px', height: '48px', backgroundColor: '#e6f4ea' }}
                                >
                                    <FiCheck style={{ color: '#34a853' }} size={22} />
                                </div>
                                <div>
                                    <div className="text-muted" style={{ fontSize: '13px' }}>Cobrados</div>
                                    <div className="fs-4 fw-bold" style={{ color: '#34a853' }}>{totalPaid}</div>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={3} sm={6}>
                    <Card style={{ border: 'none', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
                        <Card.Body className="p-3">
                            <div className="d-flex align-items-center">
                                <div
                                    className="d-flex align-items-center justify-content-center rounded-circle me-3"
                                    style={{ width: '48px', height: '48px', backgroundColor: '#fef7e0' }}
                                >
                                    <FiDollarSign style={{ color: '#f9ab00' }} size={22} />
                                </div>
                                <div>
                                    <div className="text-muted" style={{ fontSize: '13px' }}>Pendientes</div>
                                    <div className="fs-4 fw-bold" style={{ color: '#f9ab00' }}>{totalPending}</div>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={3} sm={6}>
                    <Card style={{ border: 'none', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', backgroundColor: '#1a73e8' }}>
                        <Card.Body className="p-3">
                            <div className="d-flex align-items-center">
                                <div
                                    className="d-flex align-items-center justify-content-center rounded-circle me-3"
                                    style={{ width: '48px', height: '48px', backgroundColor: 'rgba(255,255,255,0.2)' }}
                                >
                                    <FiDollarSign className="text-white" size={22} />
                                </div>
                                <div>
                                    <div className="text-white-50" style={{ fontSize: '13px' }}>Total Mes</div>
                                    <div className="fs-4 fw-bold text-white">{totalMonth.toFixed(2)} €</div>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {/* Action Buttons */}
            <div className="d-flex flex-wrap gap-2 mb-4">
                <Button
                    variant="success"
                    onClick={generateAll}
                    disabled={generatingAll || loading}
                >
                    {generatingAll ? (
                        <Spinner size="sm" className="me-2" />
                    ) : (
                        <FiFileText className="me-2" />
                    )}
                    {generatingAll ? 'Generando...' : 'Generar todos'}
                </Button>
                <Button
                    variant="outline-secondary"
                    onClick={downloadAllReceipts}
                >
                    <FiPrinter className="me-2" />
                    Imprimir recibos
                </Button>
            </div>

            {/* Table Card */}
            <Card style={{ border: 'none', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>

                <Card.Body className="p-0">
                    {/* Loading State */}
                    {loading ? (
                        <div className="text-center py-5">
                            <Spinner animation="border" style={{ color: '#1a73e8' }} />
                            <p className="mt-3 text-muted">Cargando datos del mes...</p>
                        </div>
                    ) : fees.length > 0 ? (
                        <>
                            {/* Table Header */}
                            <div className="d-none d-md-block py-3 px-3" style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #e9ecef' }}>
                                <Row className="align-items-center">
                                    <Col md={3}>
                                        <span style={{ fontWeight: 500, fontSize: '13px', color: '#5f6368', textTransform: 'uppercase' }}>
                                            Usuario
                                        </span>
                                    </Col>
                                    <Col md={1} className="text-center">
                                        <span style={{ fontWeight: 500, fontSize: '13px', color: '#5f6368', textTransform: 'uppercase' }}>
                                            Viajes
                                        </span>
                                    </Col>
                                    <Col md={1} className="text-center">
                                        <span style={{ fontWeight: 500, fontSize: '13px', color: '#5f6368', textTransform: 'uppercase' }}>
                                            Confirm.
                                        </span>
                                    </Col>
                                    <Col md={1} className="text-center">
                                        <span style={{ fontWeight: 500, fontSize: '13px', color: '#5f6368', textTransform: 'uppercase' }}>
                                            Precio
                                        </span>
                                    </Col>
                                    <Col md={1} className="text-center">
                                        <span style={{ fontWeight: 500, fontSize: '13px', color: '#5f6368', textTransform: 'uppercase' }}>
                                            Total
                                        </span>
                                    </Col>
                                    <Col md={2} className="text-center">
                                        <span style={{ fontWeight: 500, fontSize: '13px', color: '#5f6368', textTransform: 'uppercase' }}>
                                            Estado
                                        </span>
                                    </Col>
                                    <Col md={3} className="text-center">
                                        <span style={{ fontWeight: 500, fontSize: '13px', color: '#5f6368', textTransform: 'uppercase' }}>
                                            Acciones
                                        </span>
                                    </Col>
                                </Row>
                            </div>

                            {/* Table Rows */}
                            {fees.map((fee) => (
                                <div
                                    key={fee.id}
                                    className="py-3 px-3"
                                    style={{
                                        borderBottom: '1px solid #e9ecef',
                                        borderLeft: fee.py_is_paid === 1 ? '4px solid #34a853' : fee.py_id ? '4px solid #f9ab00' : '4px solid transparent',
                                        transition: 'background-color 0.2s ease'
                                    }}
                                >
                                    <Row className="align-items-center g-2">
                                        {/* User */}
                                        <Col md={3} xs={12}>
                                            <Link
                                                to={'/user/' + fee.id}
                                                className="text-decoration-none d-flex align-items-center"
                                            >
                                                <div
                                                    className="d-flex align-items-center justify-content-center rounded-circle me-2"
                                                    style={{
                                                        width: '36px',
                                                        height: '36px',
                                                        backgroundColor: '#e8f0fe',
                                                        color: '#1a73e8',
                                                        fontSize: '14px',
                                                        fontWeight: 600
                                                    }}
                                                >
                                                    {(fee.name || '?').charAt(0).toUpperCase()}
                                                </div>
                                                <span style={{ fontWeight: 500, color: '#202124' }}>
                                                    {fee.surname ? `${fee.surname}, ${fee.name}` : fee.name}
                                                </span>
                                            </Link>
                                        </Col>

                                        {/* Trips */}
                                        <Col md={1} xs={4} className="text-center">
                                            <span
                                                style={{
                                                    backgroundColor: '#e8f0fe',
                                                    color: '#1a73e8',
                                                    padding: '4px 10px',
                                                    borderRadius: '12px',
                                                    fontWeight: 600,
                                                    fontSize: '13px'
                                                }}
                                            >
                                                {fee.numTrips}
                                            </span>
                                        </Col>

                                        {/* Confirmed */}
                                        <Col md={1} xs={4} className="text-center">
                                            <span
                                                style={{
                                                    backgroundColor: '#e6f4ea',
                                                    color: '#34a853',
                                                    padding: '4px 10px',
                                                    borderRadius: '12px',
                                                    fontWeight: 600,
                                                    fontSize: '13px'
                                                }}
                                            >
                                                {fee.numConfirmed}
                                            </span>
                                        </Col>

                                        {/* Price */}
                                        <Col md={1} xs={4} className="text-center">
                                            <span style={{ color: '#5f6368', fontWeight: 500, fontSize: '14px' }}>
                                                {parseFloat(fee.price).toFixed(2)} €
                                            </span>
                                        </Col>

                                        {/* Total */}
                                        <Col md={1} xs={6} className="text-center">
                                            <span style={{ color: '#1a73e8', fontWeight: 700, fontSize: '14px' }}>
                                                {parseFloat(fee.totalPrice).toFixed(2)} €
                                            </span>
                                        </Col>

                                        {/* Status */}
                                        <Col md={2} xs={6} className="text-center">
                                            {fee.py_id ? (
                                                fee.py_is_paid === 1 ? (
                                                    <Badge
                                                        bg="success"
                                                        className="d-inline-flex align-items-center"
                                                        style={{ padding: '6px 12px', fontSize: '12px' }}
                                                    >
                                                        <FiCheck className="me-1" />
                                                        Cobrado
                                                    </Badge>
                                                ) : (
                                                    <Button
                                                        size="sm"
                                                        variant="warning"
                                                        onClick={() => collect(fee.py_id)}
                                                        disabled={collectingId === fee.py_id}
                                                    >
                                                        {collectingId === fee.py_id ? (
                                                            <Spinner size="sm" />
                                                        ) : (
                                                            <>
                                                                <FiDollarSign className="me-1" />
                                                                Cobrar
                                                            </>
                                                        )}
                                                    </Button>
                                                )
                                            ) : (
                                                <span className="text-muted" style={{ fontSize: '13px' }}>-</span>
                                            )}
                                        </Col>

                                        {/* Actions */}
                                        <Col md={3} xs={12} className="text-center mt-2 mt-md-0">
                                            <div className="d-flex gap-2 justify-content-center">
                                                {fee.py_id ? (
                                                    <Button
                                                        size="sm"
                                                        variant="outline-primary"
                                                        onClick={() => seePayment(fee.py_id)}
                                                    >
                                                        <FiEye className="me-1" />
                                                        Ver cobro
                                                    </Button>
                                                ) : (
                                                    fee.totalPrice > 0 && (
                                                        <Button
                                                            size="sm"
                                                            variant="primary"
                                                            onClick={() => generatePayment(fee)}
                                                            disabled={generatingId === fee.id}
                                                        >
                                                            {generatingId === fee.id ? (
                                                                <Spinner size="sm" />
                                                            ) : (
                                                                <>
                                                                    <FiFileText className="me-1" />
                                                                    Generar cobro
                                                                </>
                                                            )}
                                                        </Button>
                                                    )
                                                )}
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            ))}
                        </>
                    ) : (
                        <div className="text-center py-5">
                            <FiUsers size={48} className="mb-3" style={{ color: '#dadce0' }} />
                            <p className="text-muted">No hay datos para este mes</p>
                        </div>
                    )}
                </Card.Body>
            </Card>
        </div>
    );
}
